<div class="badge">
  <span>{{item().name}} ({{item().shortName}})</span>
  <mat-icon class="close" (click)="removeItem.emit(item())">close</mat-icon>
</div>
